/**
 * Minimal content bodies for structural, non-treatment slots. Each kind is
 * its own component so it can diverge freely (icons, durations, actions)
 * without anyone touching the appointment path again.
 */
import React from "react";
import { EventFlags, MCEventContentProps, SublocalityStrip, TimeRange } from "./parts";

/** Pause / lunch break. */
export const BreakContent: React.FC<MCEventContentProps> = ({ event }) => (
  <>
    <TimeRange event={event} />
    <span className="mc-event-title">{event.title || "Pause"}</span>
  </>
);

/** Drive time between visits (Weg). */
export const TravelContent: React.FC<MCEventContentProps> = ({ event }) => (
  <>
    <TimeRange event={event} />
    <span className="mc-event-title">{event.title || "Weg"}</span>
  </>
);

/** Urlaub / Krank / GoneFishing / CancelledDay — often clamped multi-day. */
export const AbsenceContent: React.FC<MCEventContentProps> = ({ event }) => (
  <>
    <TimeRange event={event} />
    <span className="mc-event-title">{event.title || event.timeSlotType}</span>
  </>
);

/** Named events, sales slots and anything unrecognized. */
export const GenericContent: React.FC<MCEventContentProps> = ({ event }) => (
  <>
    <TimeRange event={event} />
    <span className="mc-event-title">
      {event.patientLabel || event.title || event.timeSlotType}
    </span>
    <span className="mc-event-meta">
      <EventFlags event={event} />
    </span>
    <SublocalityStrip event={event} full={false} />
  </>
);
